import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Default from "../../components/layouts/default";
import ClientService from "../../services/client.service";
import { setClient, setClientId } from "../../feature/client.slice";
import ScoreCard from "./ScoreCard";
import RecentThreads from "./RecentThreads";
import ListCard from "./ListCard";
import { fetchAllThreads } from "../../feature/chat.slice";
import chatService from "../../services/chat.service";

const Dashboard = () => {
  const dispatch = useDispatch();
  const client = localStorage.getItem("client");
  const clientIds = JSON.parse(client);
  const [userName, setUserName] = useState("");
  const [Threads, setThreads] = useState([]);
  const [files, setfiles] = useState([]);
  const [notDoneTask, setnotDoneTask] = useState("");
  const [unreadCount, setunreadCount] = useState("");
  const [TotalTask, setTotalTask] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
   const [dataLoading, setdataLoading] = useState(false);
  const fetchThreads = async () => {
    try {
      setdataLoading(true)
      const threads = await chatService.getdashboardstats();
      setThreads(threads.threads);
      setfiles(threads.recentFiles);
      setnotDoneTask(threads.pendingTask);
      setunreadCount(threads.unreadMessageCount);
      setTotalTask(threads.totalTask);
      if (threads.clientDetails && threads.clientDetails.length > 0) {
        dispatch(setClient(threads.clientDetails));
      }
    } catch (err) {
      setThreads([]);
      console.log(err);
    } finally {
    setdataLoading(false); 
  }
  };

  useEffect(() => {
    const storedUserName = localStorage.getItem("userName");
    setUserName(storedUserName);
    fetchThreads();
  }, [dispatch, client]);

  // Inline so they need no icon font (this app loads none).
  const svg = (paths) => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor"
         strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">{paths}</svg>
  );
  const icons = {
    chat: svg(<path d="M21 11.5a8.4 8.4 0 0 1-9 8.4 9 9 0 0 1-3.3-.6L3 21l1.8-5a8.4 8.4 0 0 1-.8-3.6 8.4 8.4 0 0 1 9-8.4 8.4 8.4 0 0 1 8 7.5z" />),
    task: svg(<><path d="M9 11l3 3L22 4" /><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" /></>),
    docs: svg(<><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" /><path d="M14 2v6h6" /><path d="M8 13h8" /><path d="M8 17h5" /></>),
  };

  return (
    <Default
      className="dashboard"
      pageTitle={userName ? `Welcome back, ${userName}` : "Welcome back"}
      pageSubTitle="Your chats, tasks and documents with the ADM team, in one place."
    >
      <div className="stat-grid mb-4">
        <ScoreCard
          title="Unread chats"
          value={unreadCount}
          icon={icons.chat}
          tone="primary"
          linkLabel="Open chats"
          redirectPath="/chats"
          dataLoading={dataLoading}
        />
        <ScoreCard
          title="Pending tasks"
          value={notDoneTask}
          total={TotalTask}
          icon={icons.task}
          tone="warning"
          linkLabel="View tasks"
          redirectPath="/tasks"
          dataLoading={dataLoading}
        />
        <ScoreCard
          title="Documents"
          icon={icons.docs}
          tone="success"
          linkLabel="Open documents"
          redirectPath="/documents"
          dataLoading={dataLoading}
        >
          <span className="stat-card__hint">Upload and find your files</span>
        </ScoreCard>
      </div>

      <div className="row g-4">
        <div className="col-lg-7">
          <RecentThreads Threads={Threads || []} dataLoading={dataLoading} />
        </div>
        <div className="col-lg-5">
          <ListCard title="Recent documents" files={files || []} dataLoading={dataLoading} />
        </div>
      </div>
    </Default>
  );
};

export default Dashboard;
